import PolicyCostLineItem from './PolicyCostLineItem';

export default class PolicyCost {
	public totalCost: number | null = null;
	public lineItems: PolicyCostLineItem[] = [];

	public constructor() {

	}
};